{
    "Profile_Policy_Sales.salesStats": "FR: Sales Stats",
    "Profile_Policy_Sales.leadDetails": "FR: Lead Details",
    "Profile_Policy_Sales.rejectedReason": "FR: Rejected Reason",
    "Profile_Policy_Sales.lostReason": "FR: Lost Reason",
    "Profile_Policy_Sales.annualSavings": "FR: Annual Savings"
}
